import React from "react";

function Contactanos(props) {
  return (
    <section className={`${props.classContainer} flex items-center pb-10`}>
      <div className="w-1/2 flex flex-col gap-5 m-20">
        <h2 className={`text-5xl font-bold font-Bebas ${props.classTitulo}`}>
          {props.titulo}
        </h2>
        <p>{props.texto}</p>
        <a href={props.link} target="_blank" rel="noreferrer" className={`${props.classBoton} w-max px-7 py-4 text-4xl rounded-full rounded-tl-none font-Bebas`} >{props.boton} </a>
      </div>
      <div className="w-1/2 overflow-hidden rounded-30 rounded-tr-none m-5 shadow-xl h-[500px]">
        <img className="object-cover w-full h-full hover:scale-110 transition duration-300" src={props.img} alt="Registrate con nosotros" />
      </div>
    </section>
  );
}

export default Contactanos;
